import React from "react";
import PanelGroupController from "../../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../../components/panels/PropertiesList";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {Query} from "react-apollo";
import {PALLET} from "../../../queries/inventory";

const OtherPalletPropertiesPanel = (props) => {

  let elements = null;
  if (!props.selectedPalletId) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let properties = fromJS([
      {prop: "palletId", label: "Pallet id", type: "string"},
      {prop: "state", label: "State", type: "string"},
      {prop: "sku", label: "SKU", type: "id"},
      {prop: "quantity", label: "Items", type: "integer"},
      {prop: "createdAt", label: "Recorded", type: "utc"}
    ])
    let variables = {palletId: props.selectedPalletId}
    elements = (
      <Query query={PALLET} variables={variables} skip={!props.selectedPalletId}>
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          let pallet = fromJS(data.pallet);
          return (
            <PropertiesList properties={properties} data={pallet} />
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Pallet" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

export default OtherPalletPropertiesPanel;